import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../shared/utility';

interface ISavedSearchesState {
  items: any;
  initialized: boolean;
}

const initialState: ISavedSearchesState = {
  items: [],
  initialized: false
};

const savedSearchesInit = ( state: ISavedSearchesState, action: any ) => {
  return updateObject( state, { items: action.searchData, initialized: true } );
};


const addSavedSearch = ( state: ISavedSearchesState, action: any ) => {
  if (action.searchData.isDefault) {
    return updateObject( state, { items: state.items.map((item: any) => updateObject(item, {isDefault: false})).concat( action.searchData ) } );
  } else {
    return updateObject( state, { items: state.items.concat( action.searchData ) } );
  }
};

const removeSavedSearch = ( state: ISavedSearchesState, action: any ) => {
    return updateObject( state, {
      items: state.items.filter((search:any) => search.datatype !== action.searchData.datatype)
    } );
};

const setDefaultSavedSearch = ( state: ISavedSearchesState, action: any ) => {
  return updateObject( state, {
    items: state.items.map((search:any) => {
      return updateObject(search, {isDefault: (search.datatype === action.searchData.datatype)});
    })
  });
};

const selectSavedSearch = ( state: ISavedSearchesState, action: any ) => {
  return updateObject( state, {
    items: state.items.map((search:any) => {
      return updateObject(search, {isSelected: (search.datatype === action.searchData.datatype)});
    })
  });
};

const clearSelectedSavedSearch = ( state: ISavedSearchesState, action: any ) => {
  return updateObject( state, {
    items: state.items.map((search:any) => {
      return updateObject(search, {isSelected: false});
    })
  });
};

const reducer = ( state = initialState, action: any ) => {
  switch ( action.type ) {
    case actionTypes.SAVED_SEARCH_INIT:
      return savedSearchesInit( state, action );
    case actionTypes.SAVED_SEARCH_ADD:
      return addSavedSearch( state, action );
    case actionTypes.SAVED_SEARCH_REMOVE:
      return removeSavedSearch( state, action );
    case actionTypes.SAVED_SEARCH_SET_DEFAULT:
      return setDefaultSavedSearch( state, action );
    case actionTypes.SAVED_SEARCH_SELECT:
      return selectSavedSearch( state, action );
    case actionTypes.SAVED_SEARCH_CLEAR_SELECTED:
      return clearSelectedSavedSearch( state, action );
    default:
      return state;
  }
};

export default reducer;
